import { useState, useEffect } from "react";
import Cookies from "js-cookie";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) setVisible(true);
  }, []);

  const acceptCookies = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 });
    setVisible(false);
    window.location.reload(); // Recarga para que carguen los scripts
  };

  const rejectCookies = () => {
    Cookies.set("cookieConsent", "rejected", { expires: 365 });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", bottom: 0, width: "100%",
      background: "#003366", color: "#fff",
      padding: "20px", textAlign: "center", zIndex: 9999
    }}>
      <h3>Aviso de Cookies</h3>
      <p style={{ color: "#fff" }}>
        En nuestro sitio web utilizamos cookies de funcionalidad esencial y de terceros o tecnologías similares 
        con fines técnicos y para otros fines (experiencia de usuario, personalización, etc.) 
      <br></br>
        según lo especificado en la política de cookies. 
        Puede otorgar, denegar o retirar libremente su consentimiento en cualquier momento.
      </p>
      <a className="btn btn-light" href="/politica-cookie" style={{ marginRight: "10px" }}>
        Más información
      </a>
      
      <button className="btn btn-light" onClick={rejectCookies} style={{ marginRight: "10px" }}>
        Rechazar todas
      </button>
      <button className="btn btn-primary" onClick={acceptCookies} style={{ background: "#00bfff", color: "#000" }}>
        Aceptar todas
      </button>
    </div>
  );
}